import { Component, OnDestroy, OnInit } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import { GoogleMapLocation } from '@app/core/models/google-map-location.model';
import {
  AuthSelectors,
  GlobalSelectors,
  SiteActions,
  SiteSelectors,
} from '@app/store';
import { Store } from '@ngrx/store';
import { CP_PERMISSIONS } from '@app/shared/app.constants';
import { switchMap, distinctUntilChanged, filter } from 'rxjs/operators';

@Component({
  selector: 'app-dashboard-page',
  templateUrl: './dashboard-page.component.html',
  styleUrls: ['./dashboard-page.component.scss'],
})
export class DashboardPageComponent implements OnInit, OnDestroy {
  allActiveSitesForMap$: Observable<GoogleMapLocation[]> = this.store.select(
    SiteSelectors.getAllActiveSitesForMap
  );

  isSitesLoading$: Observable<boolean> = this.store.select(
    SiteSelectors.isSitesLoading
  );

  subscriptions: Subscription = new Subscription();
  showCalendar: boolean = false;

  constructor(private store: Store) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.store
        .select(AuthSelectors.getUserPermissions)
        .pipe(
          switchMap(userPermissions =>
            this.store.select(GlobalSelectors.getSelectedGlobalFilters).pipe(
              filter(
                selectedBillingAcc =>
                  userPermissions.includes(
                    CP_PERMISSIONS.SITES_SITEINFO_READ
                  ) && selectedBillingAcc.billingAccounts.length > 0
              ),
              distinctUntilChanged((prev, curr) => {
                return JSON.stringify(prev) === JSON.stringify(curr);
              })
            )
          )
        )
        .subscribe(selectedBillingAcc => {
          this.store.dispatch(SiteActions.sitesStartLoading());
          this.store.dispatch(
            SiteActions.getSites({ requestBody: selectedBillingAcc })
          );
        })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
